// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___3KX_W","link":"styles-module__link___2cX4x"};